<div class="tw-pt-[30px] md:tw-pt-0 tw-flex tw-flex-col tw-gap-[42px]">
    <div
        class="tw-flex tw-flex-col tw-items-start md:tw-items-center tw-justify-center tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-gap-[18px]"
    >
        <span
            class="lg:tw-text-[28px] tw-text-[22px] tw-leading-[140%] tw-font-bold tw-text-[#024B3F] tw-gap-[18px] lg:tw-w-[748px] md:tw-w-[500px] tw-text-start md:tw-text-center"
            >{{ capacityData?.title }}</span
        >
        <span
            class="tw-text-black tw-text-[14px] tw-font-normal tw-leading-[22px] tw-items-start md:tw-items-center tw-gap-[18px] lg:tw-w-full md:tw-w-[473px] tw-text-start md:tw-text-center defult-html"
            [innerHTML]="capacityData?.description"
        ></span>
    </div>
    <app-sub-tabs
        [tabs]="tabs"
        [mainTabSlug]="'capacity-building'"
        [selectedTab]="tabHandler.activeTab"
    ></app-sub-tabs>

    <!-- References to components -->
    <ng-template #step1>
        <app-step-1 [trainingCards]="step1data"></app-step-1>
    </ng-template>
    <ng-template #step2>
        <app-step-2 [toolsCards]="step2data"></app-step-2>
    </ng-template>
    <ng-template #step3>
        <app-step-3 [conferenceCards]="step3data"></app-step-3>
    </ng-template>
</div>
